export function updateArrayIndexFp<T>(
  array: Array<T>,
  index: number,
  updater: (field: T) => T,
): Array<T> {
  return array.map((item, i) => (i === index ? updater(item) : item));
}
